var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "#001D23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8886 5.42381C21.8145 5.34958 21.7265 5.3125 21.625 5.3125H16.375C16.2734 5.3125 16.1855 5.34958 16.1113 5.42381C16.0371 5.49813 16 5.58598 16 5.68755C16 5.78909 16.0371 5.87695 16.1113 5.9512L18.7363 8.57617C18.8106 8.6504 18.8985 8.68757 19 8.68757C19.1015 8.68757 19.1895 8.6504 19.2637 8.57617L21.8886 5.95118C21.9628 5.87695 22 5.78909 22 5.68753C22 5.58598 21.9628 5.49813 21.8886 5.42381Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.1,
    rx: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4.2998,
    width: 14,
    height: 1.1,
    rx: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8.6001,
    width: 14,
    height: 1.1,
    rx: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 12.8999,
    width: 14,
    height: 1.1,
    rx: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropMenu);
export default __webpack_public_path__ + "static/media/dropMenu.54075ef6.svg";
export { ForwardRef as ReactComponent };